export const LinkAgentRegDoc =
	'https://m365.cloud.microsoft/chat/?titleId=T_d194c0dc-98e0-2b14-ad2c-b92b4c8b8c8e&source=embedded-builder';
export const LinkAgentRequirement =
	'https://m365.cloud.microsoft/chat/?titleId=T_2e9159bd-ca23-744d-967d-ca726150eabb&source=embedded-builder';
export const LinkAgentPOGIS =
	'https://m365.cloud.microsoft/chat/?titleId=T_16860618-77de-91ad-5840-dac518a6c94f&source=embedded-builder';

export const LinkSharePointRegDoc1 =
	'https://porsche.sharepoint.com/sites/TRACE-Copilot/Lists/regulatoryDocuments/AllItems.aspx';
export const LinkSharePointRegDoc2 =
	'https://porsche.sharepoint.com/:f:/r/sites/TRACE-Copilot/Shared%20Documents/TRACE?d=wfc0bf163f98943b08a84a4ee6e84d278&csf=1&web=1&e=04ongD';
export const LinkSharePointRequirement =
	'https://porsche.sharepoint.com/sites/TRACE-Copilot/Lists/requirements/AllItems.aspx';
export const LinkSharePointPOGIS =
	'https://porsche.sharepoint.com/sites/TRACE-Copilot/Lists/pogisDocuments/AllItems.aspx';
export const LinkDataDescription =
	'https://porsche.sharepoint.com/:w:/r/sites/TRACE-Copilot/Shared%20Documents/Info/Datenstruktur_Laienverstaendlich.docx?d=w3872b1d7d9f542e5aa7240b2079b0e1c&csf=1&web=1&e=IhrSZi';
